import Permission from 'models/Permission';
import React from 'react';

const PermissionContext = React.createContext<Permission[]>([]);

export default PermissionContext;
